import logo from "./Kegonberg_header.png";
import "./App.css";
import { BrowserRouter, Route, Routes, NavLink } from "react-router-dom";
import { Entry } from "./pages/Entry";
import Navbar from "react-bootstrap/Navbar";
import { Container, Nav } from "react-bootstrap";
import { LinkContainer } from "react-router-bootstrap";
import { Rank } from "./pages/Rank";
import { CpRank } from "./pages/CpRank";

function App() {
  return (
    <>
      <BrowserRouter>
        <Navbar bg="light">
          <Container>
            <Navbar.Brand>
              <img src={logo} width="70" height="30" alt="kegonberug" />
            </Navbar.Brand>

            <Nav className="me-auto">
              <Nav.Link as={NavLink} to="/">
                順位
              </Nav.Link>
              <Nav.Link as={NavLink} to="/entry">
                選手
              </Nav.Link>

              <LinkContainer to="/cp-rank">
                <Nav.Link>CP別</Nav.Link>
              </LinkContainer>
            </Nav>
            <Nav>
              <Navbar.Brand>
                Powered by
                <img
                  src="https://static.infragistics.com/marketing/Website/General/Infragistics-horizontal.svg"
                  alt="Infragistics"
                />
              </Navbar.Brand>
            </Nav>
          </Container>
        </Navbar>

        <Routes>
          <Route path="/" element={<Rank />} />
          <Route path="/entry" element={<Entry />} />
          <Route path="/cp-rank" element={<CpRank />} />
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
